module.exports = __webpack_public_path__ + "static/stylish-104ed46738a2888bd5030a094dace040.png";